"use client";
import { Tag, Typography, Table } from "antd";

const { Text } = Typography;

const Preview = (props) => {
  const {
    formData,
    customerSegmentOptions,
    transactionRestriction,
    statementCycleOptions,
    filteredWalletProduct,
  } = props;

  console.log(filteredWalletProduct);

  const formatFullDate = (date) => {
    if (!date) return "-";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  };

  const data = [
    {
      section: "Product Information",
      items: [
        {
          name: "Product Name",
          value: formData?.prodInfo?.productId
            ? filteredWalletProduct?.savingsProductData?.name
            : "-",
        },
        {
          name: "Currency Basic",
          value: formData?.prodInfo?.currencyName
            ? formData.prodInfo.currencyName
            : "-",
          isTag: true,
        },
        {
          name: "Activation Status",
          value: filteredWalletProduct?.activateWallet
            ? "Active"
            : "Inactive" ?? "-",
          isTag: true,
        },
        {
          name: "Created Date",
          value: formatFullDate(formData?.prodInfo?.submittedOnDate),
        },
      ],
    },
    {
      section: "Customer Eligibility",
      items: [
        {
          name: "KYC Level",
          value: formData?.customerEligibility?.kycLevel
            ? formData.customerEligibility.kycLevel
            : "-",
          isTag: true,
        },
        {
          name: "Transaction Restriction",
          value: (() => {
            const selected =
              formData?.customerEligibility?.transactionRestriction;

            if (!Array.isArray(selected) || selected.length === 0) {
              console.log("ar");
              return "-";
            }

            return selected.map((id) => {
              const match = transactionRestriction.find(
                (opt) => opt.value === id
              );
              return match ? match?.label : String(id);
            });
          })(),
          isTagArray: true,
        },

        {
          name: "Customer Segment",
          value: (() => {
            const selected = formData?.customerEligibility?.customerSegment;

            if (!Array.isArray(selected) || selected.length === 0) {
              console.log("ar");
              return "-";
            }

            return selected.map((id) => {
              const match = customerSegmentOptions.find(
                (opt) => opt.value === id
              );
              return match ? match?.label : String(id);
            });
          })(),
          isTagArray: true,
        },
      ],
    },
    {
      section: "Account Parameters",
      items: [
        {
          name: "Account Name",
          value: formData?.prodInfo?.name ? formData.prodInfo.name : "-",
        },

        {
          name: "Statement Cycle",
          value: (() => {
            const selected = formData?.prodInfo?.statementCycle;

            if (!Array.isArray(selected) || selected.length === 0) {
              console.log("ar");
              return "-";
            }

            return selected.map((id) => {
              const match = statementCycleOptions.find(
                (opt) => opt.value === id
              );
              return match ? match?.label : String(id);
            });
          })(),
          isTagArray: true,
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return <Text style={{ fontWeight: 500, color: "#6b7280" }}>-</Text>;
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem = index === (data[section]?.items?.length || 0) - 1;

    if (item.isTable) {
      return (
        <div
          key={`table-section-${section}-${index}`}
          style={{
            padding: "16px 24px",
            backgroundColor: "#fff",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Table
            pagination={false}
            columns={item.columns}
            dataSource={item.dataSource}
            rowKey={(record, idx) => idx}
            bordered
            size="small"
          />
        </div>
      );
    }

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  padding: "16px 24px",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>{subField.value}</span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTagArray ? (
            Array.isArray(item.value) && item.value.length > 0 ? (
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {item.value.map((val, i) => (
                  <div key={i}>{renderTag(val)}</div>
                ))}
              </div>
            ) : (
              <Text style={{ fontWeight: 500, color: "#6b7280" }}>-</Text>
            )
          ) : item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value || "-"}
            </Text>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <h1 style={{ fontSize: "24px", fontWeight: "700", margin: 0 }}>
        Preview
      </h1>
      <p
        style={{
          color: "#6b7280",
          fontWeight: "400",
          marginBottom: "24px",
          marginTop: 0,
        }}
      >
        Add description text to note for users
      </p>

      {data.map((section, sectionIndex) => (
        <div key={section.section}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            {section.section}
          </h2>

          <div
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              marginBottom: "24px",
              padding: section.table ? "16px" : "0", // optional: add padding for table section
            }}
          >
            {section.table ? (
              <Table
                columns={section.columns}
                dataSource={section.dataSource}
                pagination={false}
                rowKey={(record, index) => index}
              />
            ) : (
              section.items.map((item, index) =>
                renderRow(item, index, sectionIndex)
              )
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Preview;
